<template>
  <div class="pop-wrap">
    <div class="pop-box">
      <div class="title">
        알뜰폰 통신사 선택
      </div>
      <div class="mobile-box">
        <ul>
          <li>
            <label for="mobile5">
              <input type="radio" id="mobile5" name="mobileCo" v-model="MobilePop" value="5" checked>
              <span>SKT</span>
            </label>
          </li>
          <li>
            <label for="mobile6">
              <input type="radio" id="mobile6" name="mobileCo" v-model="MobilePop" value="6" >
              <span>KT</span>
            </label>
          </li>
          <li>
            <label for="mobile7">
              <input type="radio" id="mobile7" name="mobileCo" v-model="MobilePop" value="7" >
              <span>LG U+</span>
            </label>
          </li>
        </ul>
      </div>
      <button @click="mobileValueUpdate">
        <span>확인</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      MobilePop: '5'
    }
  },
  methods: {
    mobileValueUpdate () {
      this.$emit('mobileValueChange', this.MobilePop)
      this.MobilePop = '5'
    }
  }
}
</script>

<style>

</style>
